const fetchRecentlyViewedSpacesReducer = (state, action) => {
  switch (action.status) {
    case 'started':
      return { ...state };
    case 'success': {
      return {
        ...state,
        recentlyViewedSpaces: {
          spaceList: [...action?.payload],
          isErrored: false,
        },
      };
    }
    case 'error':
      return {
        ...state,
        recentlyViewedSpaces: {
          spaceList: action?.payload,
          isErrored: true,
        },
      };

    default:
      return state;
  }
};

export { fetchRecentlyViewedSpacesReducer };
